import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section id="kontakt" className="py-24 md:py-32 bg-[#020611] relative overflow-hidden border-t border-border" data-id="element-95">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-dot-pattern opacity-50 pointer-events-none" data-id="element-96" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-accent/10 rounded-t-full blur-[100px] pointer-events-none" data-id="element-97" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-98">
        <div className="max-w-4xl mx-auto bg-surface border border-border p-8 md:p-16 text-center" data-id="element-99">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading mb-6" data-id="element-100">
            Bereit, den ersten Sprint zu starten?
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-muted mb-10 max-w-2xl mx-auto" data-id="element-101">
            Sprechen Sie mit unserem Team über Ihr Pilotprojekt. Die ersten 10
            Partnerunternehmen erhalten Sonderkonditionen.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mb-8" data-id="element-102">
            <a href="mailto:info@pezula.net?subject=House%20Of%20AI" className="inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-hover text-[#020611] font-bold px-8 py-4 transition-colors whitespace-nowrap" data-id="element-103">
              Erstgespräch vereinbaren
              <ArrowRight size={20} data-id="element-104" />
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-sm text-muted-dark font-mono flex flex-col sm:flex-row items-center gap-1 sm:gap-2" data-id="element-105">
            <span data-id="element-106">Oder direkt:</span>
            <a href="mailto:info@pezula.net?subject=House%20Of%20AI" className="hover:text-accent transition-colors whitespace-nowrap" data-id="element-107">
              info@pezula.net
            </a>
            <span className="hidden sm:inline" data-id="element-108">|</span>
            <a href="tel:+494060776855" className="hover:text-accent transition-colors whitespace-nowrap" data-id="element-109">
              +49 40 60 77 685 55
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="mt-6" data-id="element-110">
            <a href="https://wa.me/491702922331" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-white text-[#020611] font-bold text-sm px-6 py-3 rounded-full hover:bg-gray-100 transition-colors" data-id="element-111">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-112">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-113" />
              </svg>
              WhatsApp
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}